import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
@Component({
  selector: 'app-project-view',
  templateUrl: './project-view.component.html',
  styleUrls: ['./project-view.component.scss','../../../../../../assets/sass/pages/page-users.scss']
})
export class ProjectViewComponent implements OnInit {
  projectId:any
  projectData:any
  constructor(public apiService:ApiService,private activatedroute:ActivatedRoute) {
    this.activatedroute.paramMap.subscribe(params => { 
      this.projectId = params.get('id'); 
      console.log('projectId',this.projectId)
    });
   }

  ngOnInit(): void {this.getProjectById()
  }
  getProjectById(){
    this.apiService.getProjectById(this.projectId).subscribe((res:any)=>{
      this.projectData=res.data
      console.log('project Data',this.projectData)

    })
  }

}
